import { useCallback } from "react"
import { useSearchParams } from "react-router-dom"

export type ChannelFilterValue =
  | "LOCAL_DELIVERY"
  | "SUPPLY_FREIGHT"
  | "CUSTOMER_PICKUP"
  | null

const PARAM_NAME = "channel"

export function useChannelFilter() {
  const [searchParams, setSearchParams] = useSearchParams()
  const value = (searchParams.get(PARAM_NAME) as ChannelFilterValue) ?? null

  const setValue = useCallback(
    (next: ChannelFilterValue) => {
      const updated = new URLSearchParams(searchParams)
      if (next) {
        updated.set(PARAM_NAME, next)
      } else {
        updated.delete(PARAM_NAME)
      }
      setSearchParams(updated, { replace: true })
    },
    [searchParams, setSearchParams],
  )

  return { value, setValue }
}
